import axiosInstance from "./axiosInstance";

export const createExpense = (data) => axiosInstance.post("/pos/expenses", data);
export const fetchExpenses = (params) => axiosInstance.get("/pos/expenses", { params });
